import { Subscription, combineLatest, Observable } from "rxjs";
import { CommonService } from "../../services/common.service";
import { ParameterLookup } from "../../models/parameter.model";
import { OnDestroy, Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { OrganizationLevel } from "../../models/organizationLevel.model";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
  standalone: false,
  selector: 'base-header',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ''
})
export abstract class HeaderFilteringBaseComponent implements OnInit, OnDestroy {
  headerSubscriptions: Subscription[] = [];
  subscriptions: Subscription[] = [];
  selectedParameter: ParameterLookup;
  selectedDateRange: any;
  selectedOrg: OrganizationLevel;

  constructor(protected commonService: CommonService) { }

  ngOnInit(): void {
    this.loadHeaderData();
  }

  loadHeaderData() {
    this.headerSubscriptions.forEach(s => s.unsubscribe());
    this.headerSubscriptions = [];

    const observables: Observable<any>[] = [];
    if (this.hasParameterFilter) {
      observables.push(this.commonService.selectParameterEmitter.pipe(distinctUntilChanged()));
    }
    if (this.hasOrgFilter) {
      observables.push(this.commonService.selectedOrgEmitter.pipe(distinctUntilChanged()));
    }
    if (this.inheritsHeaderDateFilter) {
      observables.push(this.commonService.selectedDateFilterEmitter.pipe(distinctUntilChanged()));
    }
    if (!observables.length) {
      return;
    }

    this.headerSubscriptions.push(
      combineLatest(observables).pipe(
        debounceTime(300),
      ).subscribe(values => {
        let i = 0;
        if (this.hasParameterFilter) this.selectedParameter = values[i++];
        if (this.hasOrgFilter) this.selectedOrg = values[i++];
        if (this.inheritsHeaderDateFilter) this.selectedDateRange = values[i++];
        this.loadData();
      })
    );
  }

  get hasDateFilter(): boolean {
    return false;
  }

  get hasOrgFilter(): boolean {
    return false;
  }

  get hasParameterFilter(): boolean {
    return false;
  }

  protected get inheritsHeaderDateFilter(): boolean {
    return this.hasDateFilter && !this.commonService.isIhRoute();
  }

  setSelectedOrg(org: OrganizationLevel) {
    this.selectedOrg = org;
    this.loadData();
  }

  setSelectedParameter(param: ParameterLookup) {
    this.selectedParameter = param;
    this.loadData();
  }

  setSelectedDateRange(range: any) {
    this.selectedDateRange = range;
    this.loadData();
  }

  loadData() {
    const isReady =
      (!this.hasOrgFilter || this.selectedOrg) &&
      (!this.hasParameterFilter || this.selectedParameter) &&
      (!this.inheritsHeaderDateFilter || this.selectedDateRange);

    if (isReady) this.loadComponentData();
  }

  abstract loadComponentData(): void;

  ngOnDestroy() {
    this.headerSubscriptions.forEach(s => s.unsubscribe());
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
